import { Routes } from '@angular/router';
import { FallbackComponent } from './@core/shared/Components/fallback/fallback.component';

export const routes: Routes = [
  { path: 'ar', redirectTo: '/home', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () =>
      import('./@theme/theme.module').then((m) => m.ThemeModule),
  },
  // { path: 'signin-oidc', component: ServicesComponent },

  {
    path: '**',
    component: FallbackComponent,
    data: { type: 'pageNotFound' },
  },
];
